/**
 *  TagTable/TagTable.vue 에서 header 데이터를 넣기위해 사용하는
 *  공통 데이터입니다.
 *  key : 데이터
 *  title: 데이터 이름
 *  type : 데이터 타입 (타입 변환할때만 필요 날짜(date),돈(money) 일때만
 *  sortable : 정렬 기능을 넣고싶을때
 *  shortText: 말줄임을 하고싶을때
 *
 */

const DEPOSIT_LIST={
    DEPOSITS:[
        {key: 'requestDate', title:'출금 요청일',  headerClasses:['width-pixel-70']},
        {key: 'accountId', title:'거래처번호',  headerClasses:['width-pixel-70']},
        {key: 'accountName', title:'거래처명',  headerClasses:['width-percent-6']},
        {key: 'itemName', title:'품목',  headerClasses:['width-pixel-70']},
        {key: 'serviceCdName', title:'납부방법명',  headerClasses:['width-pixel-70']},
        {key: 'procTypeName', title:'처리방식',  headerClasses:['width-pixel-50']},
        {key: 'paymentStatus', title:'납부상태',  headerClasses:['width-pixel-70']},
        {key: 'resultMessage', title:'결과메세지',  headerClasses:['width-pixel-70']},
        {key: 'paymentCallAmount', title:'요청금액',  headerClasses:['width-pixel-70']},
        {key: 'paymentActualAmount', title:'납부금액',  headerClasses:['width-pixel-70']},
        {key: 'paymentFee', title:'수수료',  headerClasses:['width-pixel-50']},
        {key: 'memberId', title:'납부자번호',  headerClasses:['width-pixel-100']},
        {key: 'memberPayerName', title:'납부자명',  headerClasses:['width-pixel-70']},
        {key: 'cmsStatus', title:'회원상태',  headerClasses:['width-pixel-70']},
        {key: 'paymentWithdrawalDatetime', title:'출금일자',  headerClasses:['width-pixel-70']},
        {key: 'paymentSettlementDatetime', title:'정산일자',  headerClasses:['width-pixel-70']},
        {key: 'transactionId', title:'트랜잭션ID',  headerClasses:['width-pixel-70']},
        {key: 'depositWithdrawalHistId', title:'입출금ID',  headerClasses:['width-pixel-70']},
        {key: 'cardApprovalNumber', title:'카드 승인번호',  headerClasses:['width-pixel-90']},
        {key: 'regDatetime', title:'입출금 등록일시',  headerClasses:['width-pixel-100']},
        {key: 'uptDatetime', title:'입출금 수정일시',  headerClasses:['width-pixel-100']},
        {key: 'registerUserName', title:'등록자',  headerClasses:['width-pixel-70']},
        {key: 'cpmRegDatetime', title:'cms출금 등록일시',  headerClasses:['width-pixel-100']},
        {key: 'cpmUptDatetime', title:'cms출금 수정일시',  headerClasses:['width-pixel-100']},
        {key: 'cpmDeleteYn', title:'cms출금 삭제여부',  headerClasses:['width-pixel-70']},


    ]
}

const DEVICE_LIST={
    DEVICES: [
        {key: "rentalcompanyId", title: "업체ID"},
        {key: "rentalcompanyName", title: "업체명"},
        {key: "accountId", title: "거래처ID"},
        {key: "accountName", title: "거래처명"},
        {key: "tnDeviceId", title: "장치ID"},
        {key: "serialNo", title: "시리얼"},
        {key: "firmwareVersion", title: "버전"},
        {key: "useYn", title: "사용여부"},
        {key: "installLocation", title: "설치위치"},
        {key: "uptStateDatetime", title: "상태변경일시", type: 'date'},
        {key: "ip", title: "ip"},
        {key: "remoteIp", title: "원격ip"},
        {key: "installDatetime", title: "입고일시", type: 'date'},
        {key: "deviceType", title: "장치 유형"},
        {key: "deleteYn", title: "삭제여부"},
        {key: "register", title: "등록자"},
        {key: "installWorkerName", title: "입고자명"},
    ],
}

const DEVICE_DETAIL = {
    DEVICES: [
        {key: "rentalcompanyId", title: "업체ID",width: 60},
        {key: "rentalcompanyName", title: "업체명"},
        {key: "accountId", title: "거래처ID",width:50},
        {key: "accountName", title: "거래처명"},
        {key: "tnDeviceId", title: "장치ID",width: 40},
        {key: "serialNo", title: "시리얼"},
        {key: "firmwareVersion", title: "버전"},
        {key: "saleDate", title: "판매일자", type: 'date'},
        {key: "useYn", title: "사용여부",width: 40},
        {key: "status", title: "상태"},
        {key: "installLocation", title: "설치위치"},
        {key: "uptStateDatetime", title: "상태변경일시", type: 'date'},
        {key: "ip", title: "ip"},
        {key: "remoteIp", title: "원격ip"},
        {key: "installDatetime", title: "입고일시", type: 'date'},
        {key: "installWorkerId", title: "입고직원ID"},
        {key: "deviceType", title: "장치 유형"},
        {key: "deleteYn", title: "삭제여부",width: 40},
        {key: "regDatetime", title: "등록일시", type: 'date'},
        {key: "uptDatetime", title: "변경일시", type: 'date'},
        {key: "register", title: "등록자"},
        {key: "installWorkerName", title: "입고자명"},
        {key: "loginId", title: "입고 loginId"},
    ],
    CMD: [
        {key: 'cmdId', title: 'CMD ID',width: 40},
        {key: 'rentalcompanyId', title: '임대업체 ID',width: 60},
        {key: 'monitoringPrinterId', title: '모니터링 프린터 ID',width: 60},
        {key: 'tnDeviceId', title: '장치 ID',width: 50},
        {key: 'printerSerialNo', title: '시리얼 번호'},
        {key: 'accountId', title: '거래처ID',width: 50},
        {key: 'modelName', title: '모델명'},
        {key: 'register', title: '등록자'},
        {key: 'cmd', title: '명령어',width: 40},
        {key: 'status', title: '요청 상태',width: 50},
        {key: 'result', title: '결과 코드',width: 50},
        {key: 'regDatetime', title: '등록일시', type: 'date'},
        {key: 'uptDatetime', title: '변경일시', type: 'date'},
        {key: 'data', title: '명령어 내용', shortText: true},
        {key: 'resultData', title: '결과값', shortText: true},
    ],
    CONNECTED: [
        {title: "삭제", key: "disconnect",width: 40},
        {title: "모델명", key: "modelName",width: 200,shortText: true},
        {title: "시리얼번호", key: "serialNo"},
        {title: "IP", key: "ip",width: 90},
        {title: "등록여부", key: "registStatus",width: 40},
        {title: "등록자", key: "register"},
        {title: "장치 ID", key: "tnDeviceId",width: 50},
        {title: "모니터링 ID", key: "monitoringPrinterId",width: 50},
        {title: "거래처 ID", key: "accountId",width: 50},
        {title: "프린터 장치ID", key: "printerTnDeviceId",width: 50},
        {title: "프린터 시리얼번호", key: "printerSerialNo"},
        {title: "무한잉크사용여부", key: "unlimitedInkYn",width: 50},
        {title: "프린터상태 메시지", key: "printerStateMessage"},
        {title: "프린터 상태코드", key: "printerStateCode"},
        {title: "에러유형", key: "errorType",width: 40},
        {title: "설치위치", key: "installLocation"},
        {title: "상태 변경일시", key: "uptStateDatetime", type: 'date',width: 100},
        {title: "버전", key: "firmwareVersion"},
        {title: "잉크센서 여부", key: "inkSensorYn",width: 40},
        {title: "프린터IP", key: "printerIp",width: 90},
        {title: "메모", key: "memo"},
        {title: "드럼데이터 여부", key: "hasDrumData"},
        {title: "잉크데이터 여부", key: "hasInkData"},
        {title: "센서OK 시간", key: "sensorOkDatetime", type: 'date',width: 100},
        {title: "삭제여부", key: "deleteYn",width: 40},
        {title: "프린터 등록일시", key: "printerRegDatetime", type: 'date',width: 100},
        {title: "프린터 변경일시", key: "printerUptDatetime", type: 'date',width: 100},
        {title: "프린터 등록자", key: "printerRegister"},
        {title: "프로토콜 로직아이디", key: "protocolId"},
        {title: "드럼체크", key: "pmChkDrum",width: 40},
        {title: "토너체크", key: "pmChkToner",width: 40},
        {title: "모니터링프린터 제거여부", key: "removeYn",width: 70},
        {title: "WSD 활성화여부", key: "wsd",width: 60},
        {title: "P9100 활성화여부", key: "p9100",width: 60},
        {title: "A3 수집여부", key: "a3MonitoringYn",width: 40},
    ],
    SEARCHED: [
        {title: "등록", key: "searched",width:50},
        {title: "모델명", key: "modelName",shortText: true},
        {title: "시리얼번호", key: "serialNo"},
        {title: "IP", key: "ip"},
        {title: "등록여부", key: "registStatus",width:50},
        {title: "등록자", key: "register"},
        {title: "장치ID", key: "tnDeviceId",width:50},
    ]
}

export default {
    DEVICE_LIST,
    DEVICE_DETAIL,
    DEPOSIT_LIST
}